<template>
  <!-- Pagination -->
  <h2>Pagination</h2>
  <sel-pagination
    v-model="paginationCurrentPage"
    length="100"
    totalVisible="7"
  ></sel-pagination>

  <!-- Horizontal Menu -->
  <h2>Horizontal Menu</h2>
  <nav class="main-nav" ref="menuRootElement">
  </nav>

  <!-- Badge -->
  <h2>Badge</h2>
  <p>
    <sel-badge :value="5" class="badge-custom" data-x="9" id="badge-3">
      <sel-button title="5" class="button-custom" data-x="10" id="4">Badge on button</sel-button>
    </sel-badge>
  </p>

  <p>
    <sel-button>
      <sel-badge :value="8">
        <sel-icon class="badge-icon" data-x="12" icon-name="notification"/>
      </sel-badge>
      Badge on icon
    </sel-button>
  </p>

  <!-- Menu component -->
  <sel-menu class="horizontal-menu"
            :root-element="menuRootElement"
            :is-always-active="true"
  >
    <sel-menu class="sub-menu"
              :root-element="menuRootElement"
              v-model:is-active="isMenuChildActive['menu-1']"
    >
      <template v-slot:activator="{ on, attrs, isActive }">
        <div
          v-on="on"
        >
          <a :class="{ 'menu-item': true, 'is-active': isActive }"
             v-bind="attrs"
             href="#"
          >
            Menu 1
          </a>
        </div>
      </template>

      <a class="menu-item" href="#">Menu 1-1</a>
      <a class="menu-item" href="#">Menu 1-2</a>
      <a class="menu-item" href="#">Menu 1-3</a>
      <a class="menu-item" href="#">Menu 1-4</a>
    </sel-menu>

    <sel-menu class="sub-menu"
              :root-element="menuRootElement"
              v-model:is-active="isMenuChildActive['menu-2']"
    >
      <template v-slot:activator="{ on, attrs, isActive }">
        <div
          v-on="on"
        >
          <a :class="{ 'menu-item': true, 'is-active': isActive }"
             v-bind="attrs"
             href="#"
          >
            Menu 2
          </a>
        </div>
      </template>

      <a class="menu-item" href="#">Menu 2-1</a>
      <a class="menu-item" href="#">Menu 2-2</a>
      <a class="menu-item" href="#">Menu 2-3</a>
      <a class="menu-item" href="#">Menu 2-4</a>
    </sel-menu>

    <sel-menu class="sub-menu"
              :root-element="menuRootElement"
              v-model:is-active="isMenuChildActive['menu-3']"
    >
      <template v-slot:activator="{ on, attrs, isActive }">
        <div
          v-on="on"
        >
          <a :class="{ 'menu-item': true, 'is-active': isActive }"
             v-bind="attrs"
             href="#"
          >
            Menu 3
          </a>
        </div>
      </template>

      <a class="menu-item" href="#">Menu 3-1</a>
      <a class="menu-item" href="#">Menu 3-2</a>
      <a class="menu-item" href="#">Menu 3-3</a>
      <a class="menu-item" href="#">Menu 3-4</a>
    </sel-menu>
  </sel-menu>

  <!-- Panel component -->
  <h2>Panel</h2>
  <nav ref="panelRootElement" class="panel-wrapper">
  </nav>

  <sel-panel :root-element="panelRootElement" :is-always-active="true" class="panel-custom" data-x="14">
    <sel-panel :root-element="panelRootElement" v-model:is-active="isPanelActive['menu-1']">
      <template v-slot:activator="{ open }">
        <a @click.prevent="open" class="menu-item" href="#">Menu item 1</a>
      </template>

      <sel-panel :root-element="panelRootElement" v-model:is-active="isPanelActive['menu-1-2']">
        <template v-slot:activator="{ open }">
          <a @click.prevent="open" class="menu-item" href="#">Menu item 1-2</a>
        </template>

        <a class="menu-item" href="#">Menu item 2-1</a>
        <a class="menu-item" href="#">Menu item 2-2</a>
        <a class="menu-item" href="#">Menu item 2-3</a>
      </sel-panel>

      <a class="menu-item" href="#">Menu item 1-3</a>
      <a class="menu-item" href="#">Menu item 1-4</a>
    </sel-panel>

    <sel-panel :root-element="panelRootElement" v-model:is-active="isPanelActive['menu-2']">
      <template v-slot:activator="{ open }">
        <a @click.prevent="open" class="menu-item" href="#">Menu item 2</a>
      </template>

      <a class="menu-item" href="#">Menu item 2-1</a>
      <a class="menu-item" href="#">Menu item 2-2</a>
      <a class="menu-item" href="#">Menu item 2-3</a>
    </sel-panel>
    <a class="menu-item" href="#">Menu item 3</a>
  </sel-panel>

  <!-- Slideout component -->
  <div>
    <h2>Slideout</h2>
    <sel-button class="js-test">Open slideout outside</sel-button>
    <span>&nbsp;&nbsp;&nbsp;</span>
    <sel-slideout v-model:is-active="isSlideoutActive" activator-selector=".js-test" class="slide-custom" data-x="17">
      <div class="menu-list">
        Menu list
      </div>
      <template v-slot:activator="{ open }">
        <sel-button @click="open">Open slideout in slot</sel-button>
      </template>
    </sel-slideout>
  </div>

  <!-- Image component -->
  <div>
    <h2>Image example</h2>
    <div class="sample-image">
      <sel-image
        :sources="[
          'https://via.placeholder.com/500x500',
          'https://via.placeholder.com/1000x1000',
          'https://via.placeholder.com/1500x1500'
        ]"
        :breakpoints="[
          '(max-width: 767px)',
          '(max-width: 999px)',
          '(min-width: 1000px)'
        ]"
        class="image-custom"
        data-x="13"
      ></sel-image>
    </div>
  </div>

  <!-- Icon component -->
  <div>
    <h2>Icon</h2>
    <sel-icon class="icon--test" icon-name="arrow-right"></sel-icon>
  </div>

  <!-- Button component -->
  <div>
    <h2>Button</h2>
    <sel-button class="sel-button--modifier" :attrs="{type: 'button'}">
      <span>Icon Text&nbsp;&nbsp;&nbsp;</span>
      <sel-icon class="icon--modifier" icon-name="arrow-right"></sel-icon>
    </sel-button>
  </div>

  <!-- Expansion component -->
  <div>
    <h2>Expansion</h2>
    <sel-button @click="addExpansionParagraph">Add Paragraph</sel-button>
    <sel-button @click="removeExpansionParagraph">Remove Paragraph</sel-button>

    <sel-expansion class="expansion-custom" modifier="modifier" v-model:is-active="isExpansionActive">
      <template v-slot:activator="{ toggle }">
        <h2>
          <button :aria-expanded="isExpansionActive" @click="toggle">Expansion Heading</button>
        </h2>
      </template>

      <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc diam felis, cursus vitae enim vitae, sollicitudin
        molestie augue. Praesent egestas tincidunt est, a imperdiet nibh congue vel. Donec sem mi, volutpat sed nisl a,
        fringilla commodo lectus. Pellentesque habitant morbi tristique senectus et netus et malesuada fames ac turpis
        egestas.</p>

      <p>Vivamus et elit in mi varius pulvinar et et enim. Phasellus pulvinar est libero, commodo sodales est auctor
        eget. Proin eros dolor, pellentesque eget elit vel, fermentum vehicula orci. Nulla vel diam ac mauris
        consectetur fermentum. In condimentum varius ante, eget semper urna malesuada quis. Suspendisse potenti. Quisque
        felis lectus, tincidunt in vestibulum vitae, tincidunt in justo. Donec congue, augue et mattis ultricies, dui
        massa iaculis magna, ac efficitur metus enim id mi. Cras sed dictum metus.</p>

      <p v-for="(paragraph, index) in expansionAdditionalParagraphs" :key="index">{{ paragraph }}</p>
    </sel-expansion>
  </div>

  <!-- Dialog component -->
  <div>
    <h2>Dialog/Modal</h2>
    <sel-button class="js-modal-trigger">Open modal outside</sel-button>
    <span>&nbsp;&nbsp;&nbsp;</span>
    <sel-dialog v-model:is-active="isModalActive" activator-selector=".js-modal-trigger" class="dialog-custom" data-x="12">
      <div class="menu-list">
        Modal content
      </div>
      <template v-slot:activator="{ open }">
        <sel-button @click="open">Open modal in slot</sel-button>
      </template>
    </sel-dialog>
  </div>

  <!-- Tooltip component -->
  <div>
    <h2>Tooltip</h2>
    <sel-tooltip class="tooltip-custom" data-x="19">
      <span> hover over me </span>
      <template v-slot:tooltip>
        This is text on tooltip
      </template>
    </sel-tooltip>
  </div>

  <!-- Checkbox component -->
  <div>
    <h2>Checkbox</h2>
    <sel-checkbox class="checkbox-custom" data-x="11" name="test-checkbox" v-model:checked="checkboxValue">
      Checkbox label
    </sel-checkbox>
    <p>parent value: {{ checkboxValue }}</p>

    <h2>Checkbox groups</h2>
    <sel-checkbox v-model:checked="checkboxGroup" value="option-1">Option 1</sel-checkbox>
    <sel-checkbox v-model:checked="checkboxGroup" value="option-2">Option 2</sel-checkbox>
    <sel-checkbox v-model:checked="checkboxGroup" value="option-3">Option 3</sel-checkbox>
    <sel-checkbox v-model:checked="checkboxGroup" value="option-4">Option 4</sel-checkbox>
    <sel-checkbox v-model:checked="checkboxGroup" value="option-5">Option 5</sel-checkbox>

    <p>Selected Values: {{ checkboxGroup }}</p>
  </div>

  <!-- Radio component -->
  <div>
    <h2>Radio</h2>
    <sel-radio
      name="test-radio"
      v-model="radioValue"
      v-for="n in 3"
      :key="n"
      :value="n"
      class="radio-custom"
      data-x="15"
    >
      Radio label {{ n }}
    </sel-radio>
    <p>parent value: {{ radioValue }}</p>
  </div>

  <!-- Number Control component -->
  <div>
    <h2>Number Control</h2>
    <sel-number-control v-model="quantity" :max="5">
      <template v-slot:exceeded="{ max }">
        <p>Only allow {{max}}</p>
      </template>
    </sel-number-control>
    <p>parent value: {{ quantity }}</p>
  </div>

  <!-- Input component -->
  <div>
    <h2>Text input</h2>
    <sel-text-input v-model="textInput" placeholder="This is input field" class="input-custom" data-x="18"></sel-text-input>
    <br/>
    <sel-text-input v-model="textInput" :lines="10" placeholder="This is textarea field"></sel-text-input>
    <p>parent value: {{ textInput }}</p>
  </div>

  <!-- Select component -->
  <div>
    <h2>Select</h2>
    <sel-checkbox name="test-checkbox" v-model:checked="enableValidateSelect">
      Validate Select: {{ enableValidateSelect }}
    </sel-checkbox>
    <sel-select
      :key="enableValidateSelect"
      name="test-select"
      v-model="selectValue"
      :options="selectOptions"
      :required="enableValidateSelect"
      class="select-custom"
      :data-x="dataX"
    >
      Select Options
      <template v-if="enableValidateSelect" #empty-option>
        <option value="">Select Option</option>
      </template>
    </sel-select>
    <p>parent value: {{ selectValue }}</p>
  </div>

  <!-- Validation -->
  <div>
    <h2>Validation</h2>
    <h4>Standalone Input</h4>
    <sel-text-input v-model="standaloneTextInput" placeholder="Validate Text Input" required></sel-text-input>
    <sel-text-input v-model="standaloneEmailInput" placeholder="Validate Email Input"
                    :validate-fn="validateEmail" error-message="Email is required"
                    error-class="email-input--error"></sel-text-input>
    <h4>Form</h4>
    <form @submit.prevent="formSubmit">
      <sel-text-input :ref="setInputRef" v-model="formTextInput" placeholder="Form Text Input" required></sel-text-input>
      <sel-text-input :ref="setInputRef" v-model="formEmailInput" placeholder="Form Email Input"
                      :validate-fn="validateEmail" error-message="Email is required"></sel-text-input>
      <sel-text-input v-model="textInput" :lines="10" placeholder="Form Textarea"></sel-text-input>
      <p v-if="formMessage">{{ formMessage }}</p>
      <sel-button type="submit">Submit</sel-button>
    </form>
    <h4>Form password</h4>

    <form @submit="formSubmit">
      <sel-text-input :ref="setInputRef" v-model="formEmailInput" placeholder="Form Email Input"
                      :validate-fn="validateEmail" error-message="Email is required"></sel-text-input>
      <sel-text-input
        v-model="formPassword"
        name="login_pass"
        type="password"
        placeholder="Password"
        :required="true"
      >
      </sel-text-input>
      <sel-button type="submit">Submit</sel-button>
    </form>
  </div>

  <!-- Video component -->
  <div>
    <h2>Video</h2>
    <h4>MP4 Video</h4>
    <sel-mp4-video class="sample-video" data-x="10" src="https://test-videos.co.uk/vids/bigbuckbunny/mp4/h264/1080/Big_Buck_Bunny_1080_10s_5MB.mp4"></sel-mp4-video>

    <h4>Youtube Video</h4>
    <div class="youtube-wrapper">
      <sel-youtube-video
        class="youtube-video"
        data-x="20"
        url="https://www.youtube.com/watch?v=aqz-KE-bpKQ"
        :is-custom-player="true"
        :player-vars="{ autoplay: 0, mute: 1 }"
        @unstarted="youtubeEvents.unstarted"
        @ready="youtubeEvents.ready"
        @playing="youtubeEvents.playing"
        @paused="youtubeEvents.paused"
        @ended="youtubeEvents.ended"
        @buffering="youtubeEvents.buffering"
        @cued="youtubeEvents.cued"
      >
        <template #background>
          <sel-image
            :sources="[
              'https://via.placeholder.com/500x500',
              'https://via.placeholder.com/1000x1000',
              'https://via.placeholder.com/1500x1500'
            ]"
            :breakpoints="[
              '(max-width: 767px)',
              '(max-width: 999px)',
              '(min-width: 1000px)'
            ]"
          ></sel-image>
        </template>
        <template #play>
          <sel-icon icon-name="play"></sel-icon>
        </template>
        <template #pause>
          <sel-icon icon-name="pause"></sel-icon>
        </template>
        <template #mute>
          <sel-icon icon-name="mute"></sel-icon>
        </template>
        <template #unmute>
          <sel-icon icon-name="unmute"></sel-icon>
        </template>
      </sel-youtube-video>
      <div class="youtube-messages">
        Youtube Events:
        <p v-for="(message, index) in youtubeMessages" :key="index">{{ message }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, reactive } from 'vue'
import useMegaMenu from './compositions/mega-menu'
import SelPagination from '@/components/sel-pagination/sel-pagination'
import { useRefs } from './compositions/template-ref'

export default {
  name: 'App',
  components: { SelPagination },
  setup () {
    const checkboxValue = ref(false)
    const checkboxGroup = ref([])
    const radioValue = ref(1)
    const quantity = ref(0)
    const isSlideoutActive = ref(false)
    const isModalActive = ref(false)
    const textInput = ref('')
    const standaloneTextInput = ref('')
    const standaloneEmailInput = ref('')
    const [formInputs, setInputRef] = useRefs()
    const formTextInput = ref('')
    const formPassword = ref('')
    const formEmailInput = ref('')
    const selectValue = ref('')
    const enableValidateSelect = ref(false)
    const selectOptions = ref([
      {
        label: 'Option 1',
        value: 1
      },
      {
        label: 'Option 2',
        value: 2
      },
      {
        label: 'Option 3',
        value: 3
      },
      {
        label: 'Option 4',
        value: 4
      },
      {
        label: 'Option 5',
        value: 5
      }
    ])
    const formMessage = ref('')
    const panelRootElement = ref(null)
    const isPanelActive = reactive({})
    const isExpansionActive = ref(false)
    const expansionAdditionalParagraphs = ref([])
    const menuRootElement = ref(null)
    const dataX = ref(1)

    setInterval(() => {
      dataX.value++
    }, 1000)

    const { isActive: isMenuChildActive } = useMegaMenu()

    const addExpansionParagraph = () => {
      expansionAdditionalParagraphs.value.push(`Additional paragraph #${expansionAdditionalParagraphs.value.length + 1}`)
    }

    const removeExpansionParagraph = () => {
      expansionAdditionalParagraphs.value.pop()
    }
    const youtubeMessages = ref([])

    const validateEmail = (value) => {
      return /\S+@\S+\.\S+/.test(value)
    }

    const formSubmit = () => {
      let isValid = true
      formInputs.value.forEach(input => {
        const inputValid = input.validate()
        isValid &= inputValid
      })
      if (!isValid) {
        formMessage.value = ''
        return
      }
      formMessage.value = 'Form Submitted Successfully'
    }

    const youtubeEvents = {
      unstarted: () => youtubeMessages.value.push('Unstarted'),
      ready: () => youtubeMessages.value.push('Ready'),
      playing: () => youtubeMessages.value.push('Playing'),
      paused: () => youtubeMessages.value.push('Paused'),
      ended: () => youtubeMessages.value.push('Ended'),
      buffering: () => youtubeMessages.value.push('Buffering'),
      cued: () => youtubeMessages.value.push('Cued')
    }

    const paginationCurrentPage = ref(1)

    return {
      dataX,
      isSlideoutActive,
      isModalActive,
      checkboxValue,
      checkboxGroup,
      radioValue,
      quantity,
      textInput,
      standaloneTextInput,
      standaloneEmailInput,
      formTextInput,
      formPassword,
      formEmailInput,
      formMessage,
      selectValue,
      enableValidateSelect,
      selectOptions,
      panelRootElement,
      isPanelActive,
      isMenuChildActive,
      isExpansionActive,
      expansionAdditionalParagraphs,
      addExpansionParagraph,
      removeExpansionParagraph,
      validateEmail,
      setInputRef,
      formSubmit,
      menuRootElement,
      youtubeMessages,
      youtubeEvents,
      paginationCurrentPage
    }
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.panel-wrapper {
  position: relative;
  border: 1px solid #CCCCCC;
  width: 250px;
  height: 400px;
  overflow: hidden;
}

.horizontal-menu {
  display: flex;
}

.main-nav {
  position: relative;
}

.sample-image {
  position: relative;
  width: 600px;

  &::before {
    content: '';
    display: block;
    padding-bottom: 100%;
  }
}

.sample-video {
  position: relative;
  width: 600px;

  &::before {
    content: '';
    display: block;
    padding-bottom: calc(9 / 16 * 100%);
  }
}

.menu-item {
  display: block;
}

.sel-panel {
  background: #FFFFFF;
}

.sel-menu {
  background: #FFFFFF;
  border: 1px solid #CCCCCC;
}

.sub-menu {
  position: absolute;
  top: 39px;
  left: 0;
  right: 0;
}

.badge-icon {
  color: #000000;
}

.menu-item {
  padding: 10px;

  &.is-active {
    background: #000000;
    color: #FFFFFF;
  }
}

.youtube-video {
  width: 100%;
  max-width: 600px;

  &::before {
    content: '';
    display: block;
    padding-top: calc(9 / 16 * 100%);
  }
}

.youtube-wrapper {
  position: relative;
}

.sel-youtube-video__custom-play-pause {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
</style>
